/* eslint-disable */
import React from "react";
import { useTranslation } from "react-i18next";

const ActionLogDetailsPopup = ({ actionLogData }) => {
  const { t } = useTranslation();

  const data = actionLogData || {};

  const cleanIp = (ip) => (ip ? ip.replace(/^::ffff:/i, "") : "");

  const getUserId = (user) => (user && user._id ? user._id : user);

  const formatParams = (params) => {
    if (params === null || params === undefined) return "";
    if (typeof params === "object") {
      if (Array.isArray(params) && params.length === 0) return "";
      if (!Array.isArray(params) && Object.keys(params).length === 0)
        return "";
      return JSON.stringify(params, null, 2);
    }
    return String(params);
  };

  const formattedParams = formatParams(data.params);

  const detailRows = [
    { icon: "person", label: t("User"), value: data.fullname },
    { icon: "mail", label: t("Email"), value: data.email },
    { icon: "apps", label: t("Module"), value: data.module },
    { icon: "bolt", label: t("Action"), value: data.action },
    { icon: "flag", label: t("Status"), value: data.status },
    { icon: "lan", label: t("IP Address"), value: cleanIp(data.ipaddress) },
    { icon: "event", label: t("Date"), value: data.actiondateformated },
    { icon: "link", label: t("Url"), value: data.url, breakAll: true },
    {
      icon: "badge",
      label: t("User ID"),
      value: getUserId(data.user),
      breakAll: true,
    },
    {
      icon: "hub",
      label: t("Ecosystem ID"),
      value: getUserId(data.ecosystemid),
      breakAll: true,
    },
  ];

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="actionLogDetails"
      aria-labelledby="actionLogDetailsLabel"
    >
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              history
            </span>
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="actionLogDetailsLabel"
            >
              {t("Action Log Details")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {t("Complete information about this activity")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>

      <div className="offcanvas-body p-4">
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
          <div className="d-flex flex-column gap-3">
            {detailRows.map((row, index) => (
              <div
                key={index}
                className="form-group p-3 border rounded-8 shadow-sm bg-white"
              >
                <label className="d-flex align-items-center gap-2 fs-sm fw-semibold mb-2 text-dark">
                  <span className="material-symbols-outlined icon-sm text-primary">
                    {row.icon}
                  </span>
                  {row.label}
                </label>
                <p
                  className={`fs-sm text-gray mb-0 ${
                    row.breakAll ? "text-break" : ""
                  }`}
                >
                  {row.value ? row.value : t("Not Available")}
                </p>
              </div>
            ))}

            {/* System Information - full details */}
            <div className="form-group p-3 border rounded-8 shadow-sm bg-white">
              <label className="d-flex align-items-center gap-2 fs-sm fw-semibold mb-2 text-dark">
                <span className="material-symbols-outlined icon-sm text-primary">
                  devices
                </span>
                {t("System Information")}
              </label>
              <p className="fs-sm text-gray mb-0 text-break">
                {data.systeminfo ? data.systeminfo : t("Not Available")}
              </p>
            </div>

            {/* Browser Information */}
            <div className="form-group p-3 border rounded-8 shadow-sm bg-white">
              <label className="d-flex align-items-center gap-2 fs-sm fw-semibold mb-2 text-dark">
                <span className="material-symbols-outlined icon-sm text-primary">
                  travel_explore
                </span>
                {t("Browser Information")}
              </label>
              <p className="fs-sm text-gray mb-0 text-break">
                {data.browserinfo ? data.browserinfo : t("Not Available")}
              </p>
            </div>

            {/* Params - raw request/action data (Mixed type) */}
            <div className="form-group p-3 border rounded-8 shadow-sm bg-white">
              <label className="d-flex align-items-center gap-2 fs-sm fw-semibold mb-2 text-dark">
                <span className="material-symbols-outlined icon-sm text-primary">
                  data_object
                </span>
                {t("Params")}
              </label>
              {formattedParams ? (
                <pre
                  className="fs-sm text-gray mb-0 text-break bg-light p-2 rounded-6"
                  style={{ whiteSpace: "pre-wrap", maxHeight: "300px", overflowY: "auto" }}
                >
                  {formattedParams}
                </pre>
              ) : (
                <p className="fs-sm text-gray mb-0">{t("Not Available")}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActionLogDetailsPopup;
